const initToggle = (element) => {
    element.addEventListener('click', (e) => {
        const input = element.querySelector('input');
        const activeTopic = document.querySelector('.topic-nav__item.is-active');

        element.classList.add('active');
        input.focus();
        if (activeTopic && !e.currenttarget.matches('.topic-nav__search')) {
            activeTopic.classList.remove('is-active');
        }
    });
};

export default(() => {
    const searchInputs = Array.from(document.querySelectorAll('.topic-nav__search'));
    searchInputs.forEach(input => initToggle(input));
})();
